import { Helmet } from "react-helmet-async"
import { RateSheetDetail } from "../../../../RateSheets"
import { useParams } from "../../../../router-utils"

export default function RateSheetDetailPage() {
	const { rateSheetId } = useParams("/rate-sheets/:rateSheetId")

	if (!rateSheetId) return null

	return (
		<>
			<Helmet>
				<title>Rate Sheet Detail</title>
			</Helmet>
			<RateSheetDetail id={Number(rateSheetId)} />
		</>
	)
}
